import React from "react";
import { NavLink } from "react-router-dom";
import PropTypes from "prop-types";
import classNames from "classnames/bind";

import "./button.scss";

function LinkButton({
  label,
  iconClassName,
  image,
  customClassName,
  disabled,
  viewType,
  type,
  children,
  goTo,
  state
}) {
  const buttonClasses = classNames({
    mainButton: viewType === "mainBtn",
    asLink: viewType === "noBorder",
    asLinkBig: viewType === "noBorderBig",
    transparentIcon: viewType === "transparentIcon",
    backButton: viewType === "backButton",
    clildrenBtn: viewType === "clildrenBtn",
    cancelBtn: viewType === "cancelBtn",
    removeBtn: viewType === "removeBtn",
    [customClassName]: customClassName,
    [iconClassName]: iconClassName,
  });

  return (
    <NavLink type={type} to={goTo} state={state} disabled={disabled} className={buttonClasses}>
      {image && <img src={image} alt={label} />}
      {label}
      {children && children}
    </NavLink>
  );
}

LinkButton.propTypes = {
    viewType: PropTypes.oneOf([
      "mainBtn",
      "noBorder",
      "noBorderBig",
      "transparentIcon",
      "backButton",
      "clildrenBtn",
      "cancelBtn",
      "removeBtn",
    ]),
    label: PropTypes.string,
    image: PropTypes.string,
    iconClassName: PropTypes.string,
    customClassName: PropTypes.string,
    disabled: PropTypes.bool,
    goTo: PropTypes.string,
    type: PropTypes.string,
    children: PropTypes.object,
  };
  
  LinkButton.defaultProps = {
    label: "",
    image: "",
    goTo: "",
    iconClassName: "",
    customClassName: "",
    disabled: false,
    type: "",
    children: null,
  };

export default LinkButton;
